import { Api } from './Api'

class DigitalRegistrationSigning {
  post (siteId, bankIdLogId, powerOfAttorneyId) {
    const body = {
      bankid_log_id: bankIdLogId,
      power_of_attorney_id: powerOfAttorneyId
    }
    return fetch(Api.getBaseUrl() + 'digitalregistrationsigning/' + siteId, Api.getOptions('POST', body))
  }
}

export default DigitalRegistrationSigning
